module.exports = __webpack_public_path__ + "assets/img/favicon-32x32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon-32x32.png
// module id = 1929
// module chunks = 0